export enum QrCodeImageType {
  Undefined = 0,
  Svg,
  Png,
  Jpeg,
  Pdf
}
